import React from 'react'
import PropTypes from 'prop-types'

const ProfileOutline24 = ({ className, color, height, strokeWidth, width }) => (
   <svg width={width} height={height} viewBox="0 0 24 24">
      <g
         className={className}
         stroke={color}
         strokeLinecap="round"
         strokeLinejoin="round"
         strokeWidth={strokeWidth}>
         <path d="M1,23 c0-5.523,4.477-10,10-10h2c5.523,0,10,4.477,10,10" fill="none" />
         <circle cx="12" cy="7" fill="none" r="6" />
      </g>
   </svg>
)

ProfileOutline24.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   strokeWidth: PropTypes.string,
   width: PropTypes.string
}

ProfileOutline24.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   strokeWidth: '1px',
   width: '24px'
}

export default ProfileOutline24
